import { ReactNode } from 'react';
import 'video.js/dist/video-js.css';

export default function PlayerProvider({
  children,
}: Readonly<{ children: ReactNode }>) {
  return <>{children}</>;
}
